import styled from "styled-components"

export const Body1 = styled.div`
  font-style: normal;
  font-weight: 500 !important;
  font-size: 22px;
  line-height: 29px;
  
  span {
    font-weight: 500 !important;
  }
`

export const Body2 = styled.div`
  font-weight: normal;
  font-size: 15px;
  line-height: 22px;
`

export const Title1 = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 29px;
`

export const Body3 = styled.div`
  font-size: 13px;
  line-height: 20px;
`

export const ImageCaption = styled.div`
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0.03em;
  color: #b0b0b0;
  transition: all 150ms ease-out;
`

export const BrandTitle = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 30px;
  line-height: 29px;
`

export const MenuLink = styled.div`
  font-weight: normal;
  font-size: 26px;
  line-height: 33px;
  text-decoration: none;
  color: inherit;
  transition: color 150ms ease-out;
  display: block;

  &.brand {
    color: #b0b0b0;

    &:hover {
      color: inherit;
    }
  }
`

export const Name = styled.span`
  font-weight: 500;
  font-size: 22px;
  line-height: 22px;
`
